<div class="controls">
  <button
    class="left-arrow"
    (click)="redirectToNextAction(groupInfo!.actionInfo!.prevActionId)"
    [disabled]="!groupInfo!.actionInfo!.prevActionId"
  >
    <txtb-icons type="backArrow"></txtb-icons>
  </button>
  <span class="images-count">
    {{ !!groupInfo?.actionInfo?.indexInGroup ? (groupInfo!.actionInfo!.indexInGroup + 1) : 1 }}&nbsp;z&nbsp;{{ groupInfo?.length }}
  </span>
  <button
    class="right-arrow"
    (click)="redirectToNextAction(groupInfo!.actionInfo!.nextActionId)"
    [disabled]="!groupInfo!.actionInfo!.nextActionId"
  >
    <txtb-icons type="backArrow"></txtb-icons>
  </button>
</div>
